import { Flex, Heading, Modal, Paragraph, Button } from "@ir/ui";
import DocumentUploadForm from "./DocumentUploadForm";
import { Deduction } from "@/core/entities/deduction";
import { useDeductionDocumentUpload } from "./hook";
import { useState } from "react";
import { DeductionUploadDocument } from "./atom/documentUpload/documentUpload.atoms";

interface DocumentUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  deduction: Deduction;
}

const ModalHeader = () => {
  return (
    <Flex>
      <Heading level={6} className="font-bold">
        Upload and Attach Documents
      </Heading>
      <Paragraph className="text-grey-500 m-0">Upload and attach documents to the deduction</Paragraph>
    </Flex>
  );
};

interface ModalFooterProps {
  onClose: () => void;
  isAttaching: boolean;
  documents: DeductionUploadDocument[];
  onAttach: () => void;
  isDocumentAttached: boolean;
}

const ModalFooter = ({ onClose, isAttaching, documents, onAttach, isDocumentAttached }: ModalFooterProps) => {
  return (
    <Flex gap={0.75} className="w-100">
      <Button variant="outline" color="grey" className="flex-1" onPress={onClose}>
        Cancel
      </Button>
      <Button
        variant="solid"
        color="primary"
        className="flex-1"
        onPress={onAttach}
        isDisabled={
          documents.length === 0 ||
          isAttaching ||
          documents.some(eachDoc => eachDoc.isUploading) ||
          isDocumentAttached ||
          documents.every(eachDoc => eachDoc.error)
        }
        isLoading={isAttaching}
      >
        Attach Documents
      </Button>
    </Flex>
  );
};

const DocumentUploadModal = ({ isOpen, onClose, deduction }: DocumentUploadModalProps) => {
  const { documents, isAttaching } = useDeductionDocumentUpload();
  const [attachDocumentTrigger, setAttachDocumentTrigger] = useState<number | null>(null);
  const [isDocumentAttached, setIsDocumentAttached] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      width={450}
      onClose={onClose}
      headerContent={<ModalHeader />}
      footerContent={
        <ModalFooter
          onClose={onClose}
          isAttaching={isAttaching}
          documents={documents}
          onAttach={() => setAttachDocumentTrigger(attachDocumentTrigger ? attachDocumentTrigger + 1 : 1)}
          isDocumentAttached={isDocumentAttached}
        />
      }
      zIndex={99}
    >
      <DocumentUploadForm
        attachDocumentTrigger={attachDocumentTrigger}
        deduction={deduction}
        onClose={onClose}
        isDocumentAttached={isDocumentAttached}
        setIsDocumentAttached={setIsDocumentAttached}
      />
    </Modal>
  );
};

export default DocumentUploadModal;
